import React from 'react'
import { Image } from 'src/components/ui/Image'

interface CardItem {
  image: string
  subtitle: string
  description: string
  topics: string[]
}

interface CartaoPresenteHowItWorksProps {
  title: string
  topImage?: string
  cards: CardItem[]
  footerNote?: string
}

const CartaoPresenteHowItWorks: React.FC<CartaoPresenteHowItWorksProps> = ({
  title,
  topImage,
  cards,
  footerNote,
}) => {
  return (
    <section className="w-full max-w-[1440px] mx-auto flex flex-col items-center gap-10 px-4 my-[100px]">
      <h2 className="text-2xl md:text-3xl font-semibold text-center">
        {title}
      </h2>

      {topImage && (
        <Image
          src={topImage}
          alt={title}
          className="w-40 md:w-56 object-contain mx-auto"
        />
      )}

      <div className="w-full flex md:flex-row gap-4 flex-col justify-around">
        {cards.map((card, index) => (
          <div
            key={index}
            className="flex md:w-[500px] h-[800px] flex-col bg-white rounded-lg border border-[#D9DDE1]"
          >
            <Image
              src={card.image}
              alt={card.subtitle}
              className="w-full h-[310px] object-cover rounded-lg overflow-hidden [clip-path:polygon(0_0,100%_0,100%_83%,0_95%)]"
            />

            <div className="p-9 flex flex-col">
              <h3 className="text-4xl mb-[20px]  text-[#101010]">
                {card.subtitle}
              </h3>
              <p className="text-[#15181B] mb-[40px] text-base">
                {card.description}
              </p>

              {card.topics && card.topics.length > 0 && (
                <ul className="space-y-4">
                  {card.topics.map((topic, idx) => (
                    <li key={idx} className="flex items-start gap-3">
                      <span className="text-xs flex items-center justify-center w-8 h-8 rounded-full bg-[#3643BA] text-white">
                        {idx + 1}
                      </span>

                      <p className="text-[#15181B] max-w-[260px] font-semibold">
                        {topic}
                      </p>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>
        ))}
      </div>

      {footerNote && (
        <p className="text-xs text-gray-500 text-center">{footerNote}</p>
      )}
    </section>
  )
}

export default CartaoPresenteHowItWorks
